var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecruitRegiments5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 58,
    viewBox: "0 0 135 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_22765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-143.288 -0.383669H-0.0366575V58.184H-143.288V-0.383669Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.105 -0.308107H267.366V58.2595H135.105V-0.308107Z",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106 3C120.359 3 132 14.6407 132 29C132 43.3594 120.359 55 106 55C91.6406 55 80 43.3594 80 29C80 14.6407 91.6406 3 106 3Z",
    stroke: "#1A1A18",
    strokeWidth: 2.6664,
    strokeMiterlimit: 22.9256,
    strokeDasharray: "13.33 13.33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.90175 32.7991L9.37376 31.0231L14.2296 27.0871C16.6296 25.1591 17.8296 22.823 17.8296 20.0791C17.8296 19.0711 17.4695 18.1673 16.7578 17.3592C16.0378 16.5512 15.1976 16.1431 14.2296 16.1431H14.0298C12.8778 16.1831 11.9499 16.6952 11.2457 17.6873C10.5495 18.6791 10.0536 19.7271 9.78147 20.8232C9.50974 21.911 9.37376 22.6231 9.37376 22.9511L7.93373 21.7591C7.93373 21.5191 8.26178 20.6391 8.90965 19.1191C9.56578 17.5914 10.4217 16.1993 11.4857 14.9271C12.5417 13.6553 13.7496 13.0234 15.0936 13.0234C16.1818 13.0234 17.1417 13.2793 17.9895 13.7831C18.8297 14.2873 19.5018 14.9751 20.0055 15.8471C20.5018 16.7274 20.7978 17.6874 20.8938 18.7351C20.8938 20.0394 20.5017 21.3432 19.7255 22.6631C18.9416 23.975 18.0776 25.1191 17.1417 26.1033C16.1976 27.0791 15.6776 27.5671 15.5657 27.5671C15.6617 27.5591 15.8216 27.5352 16.0536 27.5111C16.2777 27.4872 16.5495 27.479 16.8618 27.479C18.1578 27.479 19.3098 27.863 20.3015 28.6392C21.2936 29.407 21.8136 30.8631 21.8537 32.9989C21.8537 35.3192 21.2457 37.4871 20.0218 39.4949C18.8055 41.495 17.1898 43.0869 15.1818 44.2711C13.1736 45.4548 11.0775 46.0471 8.89378 46.0471C8.19751 46.0471 7.58188 45.9991 7.06175 45.9031C6.53375 45.8071 6.29375 45.7511 6.34975 45.7511V43.9831C7.00588 44.3991 7.91791 44.6071 9.09365 44.6071C10.4619 44.6071 11.8455 44.239 13.2375 43.4951C14.6295 42.751 15.7815 41.6711 16.6935 40.255C17.6055 38.8391 18.0617 37.1671 18.0617 35.2471C18.0617 33.8792 17.8377 32.7831 17.3898 31.9671C16.9498 31.1433 15.9577 30.6711 14.4138 30.5431C13.7655 30.5431 13.1019 30.7112 12.4299 31.039C11.7495 31.367 11.1576 31.7271 10.6539 32.1191C10.1496 32.5111 9.90175 32.7351 9.90175 32.7991Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.437 14.897L88.013 10.049H106.397L107.357 11.7373L89.269 42.785L87.733 41.825L103.373 13.505H90.661C89.9968 13.505 89.4451 13.601 89.021 13.8013C88.589 13.9933 88.061 14.361 87.437 14.897Z",
    fill: "#1A1A18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1211 17L46.6815 20.5786L53.2424 24.1569L46.6814 28.2358L40.1814 31.7358L33.5605 27.7358L27 24L33.5605 20.5786L40.1211 17Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5404 38.6996L27.3606 31.468L27.1814 24.2358L33.6814 27.7358L40.1812 31.7358V38.7358V46.2358L33.8609 42.4677L27.5404 38.6996Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.1814 31.7358L46.8609 28.0039L53.1814 24.2358L53.0018 31.4681L52.8224 38.7001L46.5019 42.4677L40.1814 46.2358V39.2358V31.7358Z",
    fill: "#D7B469",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.0607 32.0607C82.6464 31.4749 82.6464 30.5251 82.0607 29.9393L72.5147 20.3934C71.9289 19.8076 70.9792 19.8076 70.3934 20.3934C69.8076 20.9792 69.8076 21.9289 70.3934 22.5147L78.8787 31L70.3934 39.4853C69.8076 40.0711 69.8076 41.0208 70.3934 41.6066C70.9792 42.1924 71.9289 42.1924 72.5147 41.6066L82.0607 32.0607ZM56 32.5H81V29.5H56V32.5Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.121 14L122.681 17.5786L129.242 21.1569L122.681 25.2358L116.181 28.7358L109.561 24.7358L103 21L109.561 17.5786L116.121 14Z",
    fill: "#D9DADA",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.54 35.6996L103.361 28.468L103.181 21.2358L109.681 24.7358L116.181 28.7358V35.7358V43.2358L109.861 39.4677L103.54 35.6996Z",
    fill: "#D9DADA",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.181 28.7358L122.861 25.0039L129.181 21.2358L129.002 28.4681L128.822 35.7001L122.502 39.4677L116.181 43.2358V36.2358V28.7358Z",
    fill: "#D9DADA",
    stroke: "#1A1A18",
    strokeWidth: 0.288,
    strokeMiterlimit: 22.9256
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_22765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1122.52,
    height: 1587.4,
    fill: "white",
    transform: "translate(-760 -330)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecruitRegiments5);
export default __webpack_public_path__ + "static/media/recruit_regiments5.723239c6df8b31ac7106315feca2e46f.svg";
export { ForwardRef as ReactComponent };